<template>
    <svg
        :width="props.width"
        :height="props.height"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M7.08331 4.14163L7.26665 3.04996C7.39998 2.25829 7.49998 1.66663 8.90831 1.66663H11.0916C12.5 1.66663 12.6083 2.29163 12.7333 3.05829L12.9166 4.14163"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M8.60834 13.75H11.3833"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M7.91669 10.4166H12.0834"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
    </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    color: {
      type: String,
      default: 'rgb(var(--locumate-clr-danger))',
    },
    width: {
        type: Number,
        default: 16,
    },
    height: {
        type: Number,
        default: 16,
    },
  });
  </script>
